/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RecourseBookingDto } from '../../models/recourse-booking-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetRecourseBookingReferenceBookings$Params {
  referencedBookingId: number;
}

export function getRecourseBookingReferenceBookings(
  http: HttpClient,
  rootUrl: string,
  params: GetRecourseBookingReferenceBookings$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<RecourseBookingDto>>> {
  const rb = new RequestBuilder(rootUrl, getRecourseBookingReferenceBookings.PATH, 'get');
  if (params) {
    rb.path('referencedBookingId', params.referencedBookingId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RecourseBookingDto>>;
    }),
  );
}

getRecourseBookingReferenceBookings.PATH = '/service/v1/recoursebooking/{referencedBookingId}/referencebookings';
